
    import './styles.scoped.css';
    export default {
  "label": "awsui_label_1q5vz_ocied_5"
};
  